import(/* webpackMode: "eager" */ "/vercel/path0/src/app/calendar/page.tsx");
